import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

import { 
  IonLabel,
  IonItem,
  IonList,
  IonSelect,
  IonSelectOption,
} from '@ionic/vue';
import { useFilter } from '@/store/filter';
import { useType } from '@/store/type';
import { useUsers } from '@/store/users';

import { ref, Ref } from 'vue'
import TitleAndValue from '@/interfaces/TitleAndValue'
import Filter from '@/interfaces/Filter'


export default /*#__PURE__*/_defineComponent({
  __name: 'FilterList',
  props: {
    listClass: null
  },
  emits: ["filterChanged"],
  setup(__props: any, { emit }: { emit: ({
  (event: "filterChanged", value: void): Promise<void>,
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  listClass: string
}

const filterStore = useFilter()
const typeStore = useType()





function filterChanged(filter: Filter, newValue: string | null) {
  if(newValue == null) return
  filterStore.setFilter(filter, newValue)
  emit('filterChanged')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonList), {
    class: _normalizeClass(props.listClass)
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filterStore).filters, (filter) => {
        return (_openBlock(), _createBlock(_unref(IonItem), {
          key: filter.titel,
          class: "bg-zewotherm-lightgrey"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonLabel), null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(filter.titel), 1)
              ]),
              _: 2
            }, 1024),
            (filter.options)
              ? (_openBlock(), _createBlock(_unref(IonSelect), {
                  key: 0,
                  "cancel-text": "Abbrechen",
                  value: filter.value,
                  onIonChange: (e) => filterChanged(filter, e.target.value)
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filter.options, (option) => {
                      return (_openBlock(), _createBlock(_unref(IonSelectOption), {
                        value: option.value,
                        key: option.value
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(option.titel), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 2
                }, 1032, ["value", "onIonChange"]))
              : (filter.titel === 'Status')
                ? (_openBlock(), _createBlock(_unref(IonSelect), {
                    key: 1,
                    "cancel-text": "Abbrechen",
                    value: filter.value,
                    onIonChange: (e) => filterChanged(filter, e.target.value)
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(typeStore).statusTypes, (option) => {
                        return (_openBlock(), _createBlock(_unref(IonSelectOption), {
                          value: option.value,
                          key: option.value
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(option.titel), 1)
                          ]),
                          _: 2
                        }, 1032, ["value"]))
                      }), 128))
                    ]),
                    _: 2
                  }, 1032, ["value", "onIonChange"]))
                : (filter.titel === 'Vertrieb' || filter.titel === 'Projektleiter')
                  ? (_openBlock(), _createBlock(_unref(IonSelect), {
                      key: 2,
                      "cancel-text": "Abbrechen",
                      value: filter.value,
                      onIonChange: (e) => filterChanged(filter, e.target.value)
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(useUsers)().users.map(user => { return { titel: user.last_name + ', ' + user.first_name, value: user.id.toString() } as TitleAndValue }), (option) => {
                          return (_openBlock(), _createBlock(_unref(IonSelectOption), {
                            value: option.value,
                            key: option.value
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(option.titel), 1)
                            ]),
                            _: 2
                          }, 1032, ["value"]))
                        }), 128))
                      ]),
                      _: 2
                    }, 1032, ["value", "onIonChange"]))
                  : (filter.titel === 'Typ')
                    ? (_openBlock(), _createBlock(_unref(IonSelect), {
                        key: 3,
                        "cancel-text": "Abbrechen",
                        value: filter.value,
                        onIonChange: (e) => filterChanged(filter, e.target.value)
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(typeStore).projectTypes, (option) => {
                            return (_openBlock(), _createBlock(_unref(IonSelectOption), {
                              value: option.value,
                              key: option.value
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(option.titel), 1)
                              ]),
                              _: 2
                            }, 1032, ["value"]))
                          }), 128))
                        ]),
                        _: 2
                      }, 1032, ["value", "onIonChange"]))
                    : (filter.titel === 'Tags')
                      ? (_openBlock(), _createBlock(_unref(IonSelect), {
                          key: 4,
                          "cancel-text": "Abbrechen",
                          value: filter.value,
                          onIonChange: (e) => filterChanged(filter, e.target.value)
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(typeStore).tagTypes, (option) => {
                              return (_openBlock(), _createBlock(_unref(IonSelectOption), {
                                value: option._id,
                                key: option._id
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(option.name), 1)
                                ]),
                                _: 2
                              }, 1032, ["value"]))
                            }), 128))
                          ]),
                          _: 2
                        }, 1032, ["value", "onIonChange"]))
                      : (filter.titel === 'Enthält Checkpoint' || filter.titel === 'Fehlender Checkpoint')
                        ? (_openBlock(), _createBlock(_unref(IonSelect), {
                            key: 5,
                            "cancel-text": "Abbrechen",
                            value: filter.value,
                            onIonChange: (e) => filterChanged(filter, e.target.value)
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(typeStore).checkpointTypes, (option) => {
                                return (_openBlock(), _createBlock(_unref(IonSelectOption), {
                                  value: option.value,
                                  key: option.value
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(option.titel), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["value"]))
                              }), 128))
                            ]),
                            _: 2
                          }, 1032, ["value", "onIonChange"]))
                        : (filter.titel === 'Berechner')
                          ? (_openBlock(), _createBlock(_unref(IonSelect), {
                              key: 6,
                              "cancel-text": "Abbrechen",
                              value: filter.value,
                              onIonChange: (e) => filterChanged(filter, e.target.value)
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(typeStore).calculatorTypes, (option) => {
                                  return (_openBlock(), _createBlock(_unref(IonSelectOption), {
                                    value: option.value,
                                    key: option.value
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(option.titel), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["value"]))
                                }), 128))
                              ]),
                              _: 2
                            }, 1032, ["value", "onIonChange"]))
                          : (filter.titel === 'Team')
                            ? (_openBlock(), _createBlock(_unref(IonSelect), {
                                key: 7,
                                "cancel-text": "Abbrechen",
                                value: filter.value,
                                onIonChange: (e) => filterChanged(filter, e.target.value)
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(typeStore).teamTypes, (option) => {
                                    return (_openBlock(), _createBlock(_unref(IonSelectOption), {
                                      value: option.value,
                                      key: option.value
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(option.titel), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["value"]))
                                  }), 128))
                                ]),
                                _: 2
                              }, 1032, ["value", "onIonChange"]))
                            : _createCommentVNode("", true)
          ]),
          _: 2
        }, 1024))
      }), 128))
    ]),
    _: 1
  }, 8, ["class"]))
}
}

})